import {useEffect, useContext} from 'react'
import {withRouter} from 'react-router'
import Snowplow from '../../Snowplow'
import {SnowplowReactContext} from '../../SnowplowContextManager'
import {cleanUtmParameters} from '../../utils'

const PageViewAnalytics = ({
    location,
    history,
    analyticsContexts,
    url,
    setCustomUrl = () => {},
    onPageView = () => {}
  }) => {
  if (!global.window) {
    return null
  }

  const contexts = analyticsContexts || useContext(SnowplowReactContext),
    {pathname} = location,
    customUrl = url || setCustomUrl(pathname),
    options = customUrl ? {pageUrl: customUrl} : {}

  window.addEventListener('load', () => {
    cleanUtmParameters(location, history)
  })

  useEffect(() => {
    Snowplow.trackPageView(null, contexts, options)
    onPageView(options)
  }, [pathname])

  return null
}

export default withRouter(PageViewAnalytics)
